// Datos del panel derecho "La Brújula" (radar). Valores de muestra tomados
// del handoff de diseño — pendientes de reemplazar por datos reales de la API.
export const radarBlips = [
  { left: "58%", top: "14%", delay: 0, label: "AMBIENTAL · GEI", value: "1.240 tCO₂e" },
  { left: "12%", top: "38%", delay: 1.2, label: "AMBIENTAL · ENERGÍA", value: "12.480 kWh" },
  { left: "64%", top: "62%", delay: 2.2, label: "SEGURIDAD · PLAN ANUAL", value: "68%" },
  { left: "24%", top: "78%", delay: 3, label: "SOCIAL · DILIGENCIA", value: "5/5" },
  { left: "70%", top: "36%", delay: 0.6, label: "SEGURIDAD · LEGAL", value: "87%" },
];

export const automationTickerItems = [
  { label: "ENERGÍA", value: "12.480 kWh" },
  { label: "AGUA", value: "3.240 m³" },
  { label: "EFLUENTES", value: "98%" },
  { label: "GEI", value: "1.240 tCO₂e" },
  { label: "RESIDUOS", value: "71%" },
  { label: "VEHÍCULOS", value: "18" },
  { label: "PLAN ANUAL", value: "68%" },
  { label: "MATRIZ LEGAL", value: "87%" },
  { label: "ACCIDENTES", value: "0" },
  { label: "PERMISOS", value: "14" },
  { label: "DEBIDA DILIGENCIA", value: "5/5" },
  { label: "RIESGOS SOCIALES", value: "3" },
];
